import React from "react";
import "./Dose_Of_Peace.css";
import { Link } from "react-router-dom";

const Dose_Of_Peace = () => {
  return (
    <section className="Dose_Of_Peace">
      <div className="container">
        <div className="content_div">
          <div className="big_img_div">
            <img
              src="/assets/images/home/dose_of_peace/sliders_img.png"
              className="big_img"
            />
          </div>

          <div className="text_holder">
            <p className="main_title">Your Daily Dose of Peace</p>
            <p className="sub_title">Now Available on iOS & Play Store</p>
          </div>

          <div className="imgs_div">
            <Link to={'https://play.google.com/store/games?hl=en_IN'} target="_blank">
              <img src="/assets/images/home/dose_of_peace/playstore.png" className="img1" />
            </Link>
            <Link to={'https://play.google.com/store/games?hl=en_IN'} target="_blank">
              <img src="/assets/images/home/dose_of_peace/appstore.png" className="img1" />
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Dose_Of_Peace;
